import React from 'react'
import { FormattedMessage } from 'react-intl'
import manoLlavesCirculo from '../../assets/img/mano-llaves-circulo.png'

class Info extends React.Component {
    render() {
        return (
            <div className="info container">
                <div className="info__col1">
                    <h2>
                        <FormattedMessage id="que_es_open_home" defaultMessage="¿Que es Open Home?" />
                    </h2>
                    <div>
                        <p>
                            <FormattedMessage
                                id="info_texto_1"
                                defaultMessage="Open Home es una solución global que te permite el control total de la gestión de apertura de tus diferentes oficinas, apartamentos o estancias en general."
                            />
                        </p>
                        <p>
                            <FormattedMessage
                                id="info_texto_2"
                                defaultMessage="Se basa en una plataforma web, desde donde se pueden gestionar todo tipo de permisos a los diferentes usuarios y crear diferentes perfiles de gestión."
                            />
                        </p>
                        <p>
                            <FormattedMessage
                                id="info_texto_3"
                                defaultMessage="Además disponemos de una App para los usuarios (que también pueden usar los administradores) que nos permitirá controlar todos los recur sos (cerraduras en este caso) asociados nuestra cuenta."
                            />
                        </p>
                        <p>
                            <FormattedMessage
                                id="info_texto_4"
                                defaultMessage="El concepto es que un propietario o gestor de varias viviendas pueda gestionar los permisos de apertura de las mismas entre sus diferentes usuarios durante un tiempo determinado sin necesidad de realizar ninguna entrega ni recogida de llaves. Además conocerá los accesos realizados y podrá restringir el acceso en cualquier momento y a distancia."
                            />
                        </p>
                    </div>
                </div>
                <div className="info__col2">
                    <img alt="manoLlaveCirculo" src={manoLlavesCirculo} />
                </div>
            </div>
        )
    }
}

export default Info



// WEBPACK FOOTER //
// ./src/components/home/Info.js